import { render, staticRenderFns } from "./CreateStaffDialog.vue?vue&type=template&id=4cc07dcb&"
import script from "./CreateStaffDialog.vue?vue&type=script&lang=ts&"
export * from "./CreateStaffDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VForm,VRow})
